import React from 'react';
import LegalLayout from './LegalLayout';

function TermsOfService() {
  return (
    <LegalLayout title="Terms of Service" updated="August 2026">
      <p className="legal-disclaimer">
        This is a general-purpose terms template describing use of this website and
        the quotes it generates. It is a starting point, not legal advice — we
        recommend having it reviewed by a qualified solicitor before relying on it.
      </p>

      <h2>1. About these terms</h2>
      <p>
        These terms apply to your use of the Orca Transports Ltd website and the
        quote/enquiry forms on it. By submitting a form on this site, you agree to
        these terms.
      </p>

      <h2>2. Quotes are estimates</h2>
      <p>
        Prices generated through the instant quote tool are automated estimates based
        on the information you provide (postcodes, load type, dimensions, dates) and
        are not a binding contract or final price. Actual pricing may differ once we
        review the specifics of your job, and will be confirmed with you directly
        before any booking is made.
      </p>

      <h2>3. Accuracy of information</h2>
      <p>
        You're responsible for providing accurate collection/delivery details, load
        dimensions, and contact information. Incorrect information may affect the
        accuracy of your quote or delay our response.
      </p>

      <h2>4. Email verification</h2>
      <p>
        We verify your email address with a one-time passcode before processing quote
        or enquiry requests, to reduce spam and confirm we can reach you.
      </p>

      <h2>5. No liability for indicative pricing</h2>
      <p>
        Orca Transports Ltd is not liable for any loss arising from reliance on an
        estimated quote shown on this website prior to a confirmed booking.
      </p>

      <h2>6. Governing law</h2>
      <p>These terms are governed by the laws of England and Wales.</p>

      <h2>7. Contact us</h2>
      <p>
        Email: <a href="mailto:sales@orcatransports.com">sales@orcatransports.com</a><br />
        Phone: <a href="tel:+447501046288">+44 7501 046288</a>
      </p>
    </LegalLayout>
  );
}

export default TermsOfService;
